export const MAX_OPACITY = 1;
export const MIN_OPACITY = 0.25;
